import { createContext } from 'react';
import utils from '../../utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';

export type OpenDataRoomNodeMixpanelProps = {
  dataRoomName: string;
  ownerId: string;
  userSide: QAndASides;
  dealRoomId: string;
};

type DocumentViewContextValues = {
  openNode: (
    node: DataRoomNode,
    mixpanelProps?: OpenDataRoomNodeMixpanelProps,
    siblings?: DataRoomNode[],
  ) => void;
};

export default createContext<DocumentViewContextValues>({
  openNode: utils.noop,
});
